import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ResetTvIcon(props: IconProps) {
    return <Icon {...props} iconKey={"reset_tv"}/>
}
